<template>
  <div
    class="w-full bg-semantic-inverse-surface-light px-4 py-10 md:py-20"
    :data-testid="dataTestid"
  >
    <!-- eslint-disable vue/no-v-html -->
    <div
      class="w-full max-w-wrapper-lg mx-auto flex items-center md:gap-x-16 gap-y-8 flex-wrap lg:flex-nowrap"
    >
      <div :class="contentClass || 'w-full lg:max-w-[34.75rem]'">
        <Component
          :is="titleTag"
          v-if="title"
          class="font-hero text-semantic-inverse-on-surface font-normal md:text-[96px]/[100%] text-[62px]/[80%] mb-2 md:mb-4 break-words"
        >
          {{ title }}
        </Component>

        <div
          v-if="description"
          class="text-semantic-inverse-on-surface font-normal md:text-xl text-lg mb-6 md:mb-10"
          v-html="description"
        />

        <div
          class="flex flex-wrap w-full items-center gap-4 md:gap-6 md:flex-row flex-col"
        >
          <V2AtomsButton
            inverted
            size="large"
            class="w-full max-w-[21.4375rem] md:w-auto md:max-w-none"
            :to="to"
            @click="$emit('primary-btn-click')"
          >
            {{ primaryBtnLabel }}
          </V2AtomsButton>

          <V2AtomsButton
            v-if="hasSecondaryBtn"
            inverted
            :to="secondaryBtnTo"
            theme="secondary"
            size="large"
            class="w-full max-w-[21.4375rem]  md:w-auto md:max-w-none"
            @click="$emit('secondary-btn-click')"
          >
            {{ secondaryBtnLabel }}
          </V2AtomsButton>
        </div>
      </div>

      <NuxtImg
        v-if="image"
        alt="image"
        loading="lazy"
        :src="image"
        :width="imageWidth"
        :height="imageHeight"
        :class="imageClass"
      />
    </div>
    <!-- eslint-enable vue/no-v-html -->
  </div>
</template>

<script setup>
defineOptions({
  name: 'V2OrganismHeroSection'
})

defineProps({
  dataTestid: {
    type: String,
    default: ''
  },
  title: {
    type: String,
    default: ''
  },

  description: {
    type: String,
    default: ''
  },

  primaryBtnLabel: {
    type: String,
    default: 'Primary Action'
  },

  hasSecondaryBtn: {
    type: Boolean,
    default: true
  },

  secondaryBtnLabel: {
    type: String,
    default: 'Secondary Action'
  },

  // Local Images are stored under /public/images/authors
  image: {
    type: String,
    default: ''
  },

  to: {
    type: String,
    default: ''
  },

  secondaryBtnTo: {
    type: String,
    default: ''
  },

  titleTag: {
    type: String,
    default: 'h1',
    validator: value => {
      /**
       * checks if heading tag value is is from 1 - 6
       * returns false if its more than 6
       */
      if (value.indexOf('h') === 0 && value.length === 2) {
        return ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(value)
      }

      return value
    }
  },

  contentClass: {
    type: String,
    default: ''
  },

  imageClass: {
    type: String,
    default: ''
  },

  imageWidth: {
    type: [Number, String],
    default: 500
  },

  imageHeight: {
    type: [Number, String],
    default: 400
  }
})

defineEmits(['primary-btn-click', 'secondary-btn-click'])
</script>
